<script lang="ts">
    import Icon from "@components/Icon.svelte";
    import CloseIcon from "@components/icons/CloseIcon.svelte";

    import type DrawerManager from "./DrawerManager";

    export let drawerManager: DrawerManager;
</script>

<div class="gw-drawer-sidebar">
    <button
        class="gw-drawer-sidebar__close_btn"
        aria-label="Close sidebar"
        on:click={() => drawerManager.drawerHide()}
    >
        <Icon>
            <CloseIcon />
        </Icon>
    </button>
    <slot name="header" />
    <div class="gw-drawer-sidebar__content">
        <slot />
    </div>
</div>

<style>
    .gw-drawer-sidebar {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .gw-drawer-sidebar__close_btn {
        position: absolute;
        top: 0;
        right: 0px;
        width: 44px;
        height: 44px;
        padding: 14px;
        border: none;
        background: transparent;
        line-height: 1;
        cursor: pointer;
    }
    .gw-drawer-sidebar__close_btn :global(svg) {
        width: 100%;
        height: 100%;
    }
    .gw-drawer-sidebar__content {
        height: 100%;
        flex-grow: 1;
        height: 1px;
    }
</style>
